import Orders from "../../components/Orders";
import PageTitleComponent from "../../components/PageTitle";

export default function OrdersScreen(){
return <div>
    <PageTitleComponent title="Orders" />
    <Orders/>
</div>
}